import { firstName } from "./../../../validations/yupValidations";
import { ICreateAndUpdateUser } from "../../../types/common.interface";
import customAxios from "../../customAxios";
import { CREATE_ADMIN } from "../../routes";

const createAdmin = async (formData: ICreateAndUpdateUser) => {
  try {
    return (
      await customAxios.post(CREATE_ADMIN, {
        phoneNumber: formData.phoneNumber,
        firstName: formData.firstName,
        lastName: formData.firstName,
        permission: formData.permission,
        // financialGroupSchool: formData.financialGroupSchool._id,
      })
    ).data;
  } catch (error: unknown) {
    console.error(error);
    return false;
  }
};

export default createAdmin;
